
// Modules
import * as THREE from "three"
import gsap from "gsap"

// HelpersThree
import Cylinder2 from '../Cylinder2'
import SceneWithRaycaster from "./SceneWithRaycaster"
import utils from "../../../utils/utils"

// Data

// Constants
const INFINITE_ROTATION_Y_SPEED =  .00075

const TILT_EASE = .05
const TILT_REDUCER_X = .4
const TILT_REDUCER_Y = .05


const CYLINDER_COLOR_SECONDARY = 0x999999
const CYLINDER_COLOR_PRIMARY = 0xffffff


export default class Scene404 extends SceneWithRaycaster{
    constructor(container, parameters, data = {}){
        super(container, parameters, data)

        // variables
        this._cameraTargetPosition = new THREE.Vector3()
        
        // data
        this._directors = [1]
        this.mobileDetected = data.mobileDetected
    
        // binds
        this.onClickMesh = this.onClickMesh.bind(this)
        this.onMouseTilt = this.onMouseTilt.bind(this)

        // penchement
        this._targetMouse = new THREE.Vector2()
        this._currentMouse = new THREE.Vector2()
        this._canTilt = true

        window.Scene404 = this
    }

    /** Build */

    initScene(){
        super.initScene()

        // set camera
        this.camera.position.z = 10

        if(this.mobileDetected){
            this.camera.position.multiplyScalar(1.8)
        }

        // tilting container
        this._tiltingContainer = new THREE.Group()
        this.scene.add(this._tiltingContainer)

        this._cylindersContainer = new THREE.Group()
        this._tiltingContainer.add(this._cylindersContainer)
        this._cylindersContainer.rotation.x = -Math.PI / 64
        this._cylindersContainer.rotation.z = -Math.PI / 16

        let offsetY = 0

        for(let i = 0; i < 1; i++){

            let cylinder = new Cylinder2([
                {text: "ERROR", fontFamily: "GrtskMegaBold", fontWeight: 700, fontSize: 50},
                {text: "404", fontFamily: "GrtskMegaBold", fontWeight: 700, fontSize: 50},
                // {text: "404", fontFamily: "GrtskPetaBold", fontWeight: 700, fontSize: 35, letterSpacing: 6},
            ], {
                cylinderRadius: 5,
                repeat: 6,
                ratio: 100,
                side: THREE.FrontSide,
                radialSegments: 256,
            }).getMesh()

            // transform cylinder
            cylinder.position.y += offsetY
            cylinder.rotation.y = Math.random() * Math.PI * 2

            // user data
            let rotationSpeed = utils.randomInteger(600, 1000) * 1e-3

            cylinder.userData.rotationSpeed = rotationSpeed
            cylinder.userData.initialRotationSpeed = rotationSpeed
            
            // add to scene
            this._cylindersContainer.add(cylinder)
            
            // increment offset
            offsetY += -cylinder.geometry.parameters.height * 1.1

        }

        // center cylinders
        this._cylindersContainer.children.map(c => {
            c.position.y += (-offsetY * .5 + (offsetY / 1) * .5) * .85 // fix center-y decalage
        })

        // fix center-y decalage


        // this.intersectableObjects = this._cylindersContainer.children
    }

    /** Animate */

    _animateEntrance(){
        gsap.from(this.container, {
            duration: .6,
            opacity: 0
        })
    }

    _animateExit(onComplete){
        gsap.to(this.container, {
            duration: .6,
            onComplete: onComplete,
            opacity: 0
        })
    }

    onRender(){

        this.camera.lookAt(this._cameraTargetPosition)

        // infinite rotate
        for(let i = 0; i < this._cylindersContainer.children.length; i++){

            let child = this._cylindersContainer.children[i]
            let rotationSpeed = child.userData.rotationSpeed

            child.rotateY(INFINITE_ROTATION_Y_SPEED * rotationSpeed)
        }

        // tilting
        let tilting = utils.getRestrictedTiltingRotation(this._currentMouse, this._targetMouse, TILT_EASE)

        this._tiltingContainer.rotation.x = -tilting.tiltingX * TILT_REDUCER_Y
        this._tiltingContainer.rotation.z = -tilting.titlingZ * TILT_REDUCER_X

        this._currentMouse.set(tilting.nextX, tilting.nextY)
    }


    /** Events */

    onClickMesh(){


        let mesh = this.hoveredMesh

        if(mesh){
            // this._updateRoute(mesh.userData.slug)
        }

    }

    onMouseEnterMesh(intersect){
        super.onMouseEnterMesh(intersect)

        let mesh = intersect.object

        // pointer clickable
        document.body.style.cursor = "pointer"
        
        // animate opacity
        gsap.to(mesh.material.color, {

            r: .4,
            g: .4,
            b: .4,
        })

        // reduce rotation speed
        gsap.to(mesh.userData, {
            duration: 1,

            rotationSpeed: .35
        })
    }

    onMouseLeaveMesh(){

        let mesh = this.hoveredMesh

        // animate opacity
        gsap.to(mesh.material.color, {

            r: 1,
            g: 1,
            b: 1,
        })

        // pointer clickable
        document.body.style.cursor = ""

        // restore rotation speed
        gsap.to(mesh.userData, {
            duration: 1,

            rotationSpeed: mesh.userData.initialRotationSpeed
        })
        super.onMouseLeaveMesh()

    }

    onMouseTilt(event){

        let currentMouse = utils.getMousePosition(event)

        this._targetMouse.set(
            currentMouse[0],
            currentMouse[1]
        )
    }

    attachEvents(){
        super.attachEvents()
        this.container.addEventListener("click", this.onClickMesh)
        this.container.addEventListener("mousemove", this.onMouseTilt)
    }

    removeEvents(){
        super.removeEvents()
        this.container.removeEventListener("click", this.onClickMesh)
        this.container.removeEventListener("mousemove", this.onMouseTilt)
    }


    /** Core */

    start(){
        this._animateEntrance()
        super.start()
    }

    stop(){
        
        // restore pointer
        document.body.style.cursor = ""

        super.stop()
    }
}